import encryptedStorage from '@/stores/encryptedStorage';
import store from '@/stores/store';
import { useCallback, useEffect, useState } from 'react';

const STORAGE_KEY = 'additionalContactBannerDismissed';

const getDismissedMap = async (): Promise<Record<string, boolean>> => {
  const value = await encryptedStorage().getItem(STORAGE_KEY);
  return value && typeof value === 'object'
    ? (value as Record<string, boolean>)
    : {};
};

export const useIsAdditionalContactBannerDismissed = () => {
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    (async () => {
      const userId = store.getState().signedInUser?.user?._id;
      if (!userId) {
        return;
      }
      const map = await getDismissedMap();
      setDismissed(!!map[userId]);
    })();
  }, []);

  const dismiss = useCallback(async () => {
    const userId = store.getState().signedInUser?.user?._id;
    if (!userId) {
      return;
    }
    const map = await getDismissedMap();
    map[userId] = true;
    await encryptedStorage().setItem(STORAGE_KEY, map);
    setDismissed(true);
  }, []);

  return { isDismissed: dismissed, dismiss };
};
